<template>
    <div ref="parent" class="activechecker" :data-active="active ? 'true' : 'false'">
        <div class="activechecker__content">
            <span v-text="active ? 'Active' : 'Inactive'"></span>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            active: true,
            timeoutID: 0,
            // TODO: MAKE SURE WE'RE NOT BEING LOCKED OUT WHILE WATCHING LONG VIDEOS
            //timeToLogout: 60000, // this is 1 minute (does this stop while watching the video?)
            timeToLogout: 8 * 60000, // this is 5 minutes i guess
        }
    },
    mounted() {
        console.log('active checker: active timer initiated');
        window.activeChecker = this;
        this.addHandlers();
        this.goActive();
    },
    methods: {
        addHandlers() {
            document.addEventListener("mousemove", this.resetTimer, false);
            document.addEventListener("mousedown", this.resetTimer, false);
            document.addEventListener("keypress", this.resetTimer, false);
            document.addEventListener("DOMMouseScroll", this.resetTimer, false);
            document.addEventListener("mousewheel", this.resetTimer, false);
            document.addEventListener("touchmove", this.resetTimer, false);
            document.addEventListener("MSPointerMove", this.resetTimer, false);
        },
        startTimer() {
            this.timeoutID = window.setTimeout(
                this.goInactive,
                this.timeToLogout
            );
        },
        resetTimer() {
            window.clearTimeout(this.timeoutID);
            this.goActive();
        },
        endTimer() {
            document.removeEventListener("mousemove", this.resetTimer, false);
            document.removeEventListener("mousedown", this.resetTimer, false);
            document.removeEventListener("keypress", this.resetTimer, false);
            document.removeEventListener(
                "DOMMouseScroll",
                this.resetTimer,
                false
            );
            document.removeEventListener("mousewheel", this.resetTimer, false);
            document.removeEventListener("touchmove", this.resetTimer, false);
            document.removeEventListener(
                "MSPointerMove",
                this.resetTimer,
                false
            );
            //this.active = false; // Allow this to be started again
        },
        goInactive() {
            //console.log('*********** ACTIVE TIMER: %cINACTIVE', 'color: red;');
            this.active = false;
            //this.endTimer();
            //this.logout_link.click();
        },
        goActive() {
            //console.log('*********** ACTIVE TIMER: %cACTIVE', 'color: green;');
            this.active = true;
            this.startTimer();
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

.activechecker {
    position: fixed;
    z-index: 100000;
    pointer-events: none;
    bottom: 0;
    right: 0;
    display: none;
    opacity: 0;

    &[data-active="true"] {
        background-color: green;
    }

    &[data-active="false"] {
        background-color: red;
    }
}

.activechecker__content {
    padding: rem(10px) rem(15px);
    color: white;
}
</style>